import {Component, Property, Object3D} from "@wonderlandengine/api";
import {mat3, quat} from "gl-matrix";

/**
 * getSetRotation
 */

export function getRotationEuler() {
    const quaternionRotation = this.getRotationWorld();
    const matThree = mat3.create();
    mat3.fromQuat(matThree, quaternionRotation);

    const radian = [0, 0, 0];

    // Rotation order is ZYX
    radian[1] = Math.asin(-Math.min(Math.max(matThree[2], -1), 1));

    if (Math.abs(matThree[2]) < 1 - 0.0000001) {
        radian[0] = Math.atan2(matThree[5], matThree[8]);
        radian[2] = Math.atan2(matThree[1], matThree[0]);
    } else {
        radian[0] = 0;
        radian[2] = Math.atan2(-matThree[3], matThree[4]);
    }

    const degreesArray = radian.map((radian) => radian * (180 / Math.PI));
    return degreesArray;
};
export function setRotationEuler(eulerRotation) {
    const quatRotation = quat.create();
    quat.fromEuler(
        quatRotation,
        eulerRotation[0],
        eulerRotation[1],
        eulerRotation[2],
    );
    this.setRotationWorld(quatRotation);
};

export class GetSetRotation extends Component {
    static TypeName = "getSetRotation";
    /* Properties that are configurable in the editor */
    static Properties = {
        object1: Property.object(),
        object2: Property.object(),
    };
    start() {
        // this.obj1Rot = this.object1.getRotationEuler();
        // this.obj2Rot = this.object2.getRotationEuler();
        // this.object2.setRotationEuler([
        //     this.obj2Rot[0],
        //     this.obj1Rot[1],
        //     this.obj2Rot[2],
        // ]);

        //console.log(this.object1.getRotationEuler());
    }
}